/** @module @category Offline */ import { createGlobalStore } from "@openmrs/esm-state";
import { setupDynamicOfflineDataHandler, syncDynamicOfflineData } from "./dynamic-offline-data.js";
const store = createGlobalStore('offline-patients', {
    offlinePatientDataSyncState: {},
    handlers: {}
});
/** @deprecated Will be removed once all modules have been migrated to the new dynamic offline data API. */ export function getOfflinePatientDataStore() {
    printDeprecationWarning();
    return store;
}
/** @deprecated Will be removed once all modules have been migrated to the new dynamic offline data API. */ export function registerOfflinePatientHandler(identifier, handler) {
    printDeprecationWarning();
    setupDynamicOfflineDataHandler({
        type: 'patient',
        displayName: handler.displayName,
        id: identifier,
        isSynced: ()=>Promise.resolve(true),
        sync: (patientUuid, signal)=>handler.onOfflinePatientAdded({
                patientUuid,
                signal: signal ?? new AbortController().signal
            })
    });
}
/** @deprecated Will be removed once all modules have been migrated to the new dynamic offline data API. */ export async function syncOfflinePatientData(patientUuid) {
    printDeprecationWarning();
    await syncDynamicOfflineData('patient', patientUuid);
}
function printDeprecationWarning() {
    console.warn('The offline patient API has been deprecated and will be removed in a future release. ' + 'To prevent future crashes, the functions remain available for the moment, but any invocations should be migrated ASAP.');
}
